import ModalContainer from 'components/ModalContainer';
import Button from 'components/Button';
import MessageBox from 'components/MessageBox';

import { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import licenseService from "services/Auth.License.service";
import { messageKeyPrefix } from "utils/message.util";
import { uiActions } from "stores/slice/ui";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { isNil } from "lodash";

dayjs.extend(utc);
dayjs.extend(timezone);

const GenerateModal = ({
  isOpenGenerateModal,
  setOpenGenerateModal,
  search
}) => {
  const { t } = useTranslation();
  const { pageContext } = useSelector((store) => store);
  const [messageBox, setMessageBox] = useState({ error: null });

  const closeModal = () => {
    setMessageBox({ error: null });
    setOpenGenerateModal(false);
  };

  const generateHistory = async () => {
    try {
      // dispatch(uiActions.showSpinner());
      const localTimezone = dayjs();
      const params = {
        mspId: pageContext.si.id,
        timezone: localTimezone.format('Z'),
        expirationFrom: search.timeframe.postTimeStamp.fromDate,
        expirationTo: search.timeframe.postTimeStamp.toDate
      };
      const res = await licenseService.getMspHistoryGenerateList(params);
      if (!isNil(res.error)) {
        setMessageBox({ error: t(`${messageKeyPrefix.e.s}${res.error.code}`) });
      } else {
        closeModal();
      }
    } catch (error) {
      console.error(error);
      setMessageBox({ error: t(`${messageKeyPrefix.e.s}${1000}`) });
    } finally {
      // dispatch(uiActions.hideSpinner());
    }
  };

  return (
    <ModalContainer
      modalWidthType="modal-500px"
      openModal={isOpenGenerateModal}
      closeModal={() => closeModal()}
    >
      <div className="header">
        <div className="title">{t('d70cebf7ee')}</div>
      </div>
      <div className="body">
        <MessageBox
          show={!!messageBox.error}
          label={messageBox.error}
          variant="danger"
          dismissible
          onClose={() => {
            setMessageBox({ error: null });
          }}
        />
        <div className="mb-1">{t('f35a76fbe5')}</div>
        <div className="mb-1">{t('0a3d79c6bd')}</div>
      </div>
      <div className="footer">
        <Button
          label="Cancel"
          className="btn-cancel"
          onClick={() => closeModal()}
        />
        <Button
          label="Yes"
          className="btn-submit"
          onClick={() => generateHistory()}
        />
      </div>
    </ModalContainer>
  );
};

export default GenerateModal;